/**
 * @file コンポーネント：ログインモーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { InputCheckbox } from "~/src/components/uiparts/InputCheckbox";
import { InputText } from "~/src/components/uiparts/InputText";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// スタイル読み込み
import {
    StyledModal,
    StyledModalContainer,
    StyledModalContainerAnchor,
    StyledModalContainerButton,
    StyledModalContainerButtonlist,
    StyledModalContainerButtonlistItem,
    StyledModalContainerContent,
    StyledModalContainerHeadline,
    StyledModalContainerNotelist,
    StyledModalContainerNotelistItem,
    StyledModalHeadline,
    FadeInParagraph,
    StyledFormInputWrapper,
    StyledFormListDetailPassword,
    StyledFormListDetailShowPasswordIcon,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            content={[
                <StyledModal key="modal">
                    <StyledModalHeadline>
                        {localized["Label.Login"]}
                    </StyledModalHeadline>
                    <StyledModalContainer>
                        {props.loginErrorMessages.length !== 0 &&
                            props.loginErrorMessages.map((message, index) => (
                                <FadeInParagraph key={`${message}-${Date.now()}-${index}`}>
                                    {message}
                                </FadeInParagraph>
                            ))}
                        <StyledModalContainerContent>
                            <InputText
                                name="Email"
                                onKeyDown={(e) => props.fnPressEnter(e)}
                                placeholder={localized["Label.MailPlaceholder"]}
                                refInputText={props.refInputEmail}
                                type="mail"
                            />
                        </StyledModalContainerContent>
                        <StyledModalContainerContent>
                        <StyledFormListDetailPassword>
                            <StyledFormInputWrapper
                                className=""
                            >
                                <InputText
                                    id="PasswordHash"
                                    isWide={true}
                                    minlength="8"
                                    name="PasswordHash"
                                    onKeyDown={(e) => props.fnPressEnter(e)}
                                    refInputText={props.refInputPassword}
                                    type={
                                        props.isShowPassword
                                            ? "text"
                                            : "password"
                                    }
                                />
                            </StyledFormInputWrapper>
                            <StyledFormListDetailShowPasswordIcon
                                onClick={(e) => { e.preventDefault() }}
                                onContextMenu={(e) => e.preventDefault()}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    props.setIsShowPassword(true);
                                }}
                                onMouseUp={() => props.setIsShowPassword(false)}
                                onMouseLeave={() => props.setIsShowPassword(false)}
                                onTouchStart={() => props.setIsShowPassword(true)}
                                onTouchEnd={() => props.setIsShowPassword(false)}
                            >
                                <i className="fas fa-solid fa-eye"></i>
                            </StyledFormListDetailShowPasswordIcon>
                        </StyledFormListDetailPassword>
                        </StyledModalContainerContent>
                        <StyledModalContainerContent data-text-align="right">
                            <StyledModalContainerAnchor href="/new-password">
                                {localized["Label.NewPasswordHeader"]}
                            </StyledModalContainerAnchor>
                        </StyledModalContainerContent>
                        <StyledModalContainerContent data-text-align="center">
                            <InputCheckbox
                                defaultChecked={false}
                                name={"KeepLogin"}
                                refInputCheckbox={props.refInputKeepLogin}
                                text={localized["Label.KeepLogin"]}
                            />
                        </StyledModalContainerContent>
                        <StyledModalContainerButtonlist>
                            <StyledModalContainerButtonlistItem>
                                <StyledModalContainerButton
                                    href="#"
                                    onClick={(e) => props.fnClickLogin(e)}
                                >
                                    {localized["Label.Login"]}
                                </StyledModalContainerButton>
                            </StyledModalContainerButtonlistItem>
                        </StyledModalContainerButtonlist>
                        <StyledModalContainerNotelist>
                            <StyledModalContainerNotelistItem>
                                {localized["Label.ChromiumEngineNotice"]}
                            </StyledModalContainerNotelistItem>
                        </StyledModalContainerNotelist>
                        <StyledModalContainerContent data-text-align="right">
                            <StyledModalContainerAnchor href="/accessibility">
                                {localized["Label.CheckSystemRequirements"]}
                            </StyledModalContainerAnchor>
                        </StyledModalContainerContent>
                        <StyledModalContainerHeadline>
                            {localized["Label.CreateYourAccount"]}
                        </StyledModalContainerHeadline>
                        <StyledModalContainerButtonlist>
                            <StyledModalContainerButtonlistItem>
                                <StyledModalContainerButton
                                    href={`/temp-registration${props.parameteRefPage ? `/?refPage=${props.redirectUrl}` : `/?refPage=${encodeURIComponent(window.location.href)}`}`}
                                >
                                    {localized["Label.Register"]}
                                </StyledModalContainerButton>
                            </StyledModalContainerButtonlistItem>
                        </StyledModalContainerButtonlist>
                    </StyledModalContainer>
                </StyledModal>,
            ]}
            hasButtonClose={true}
            isShow={props.isOpenModalLogin}
            setIsShow={props.setIsOpenModalLogin}
        />
    );
};
